import { type EditionAwarenessContextType } from './edition-awareness-context';
import { isProductOneOf } from './is-product-one-of';

export const isEligibleForFreeToStandardUpgrade = (context: EditionAwarenessContextType) => {
	return (
		context.edition === 'free' &&
		isProductOneOf(context.product, ['jira', 'jira-service-management', 'jira-product-discovery'])
	);
};
